import React from 'react';
import { HeroVariant62 } from '../components/HeroVariant62';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage62() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1750">
      <Navigation data-id="element-1751" />
      <main data-id="element-1752">
        <HeroVariant62 data-id="element-1753" />
        <WhyUs data-id="element-1754" />
        <Services data-id="element-1755" />
        <FAQ data-id="element-1756" />
        <Testimonials data-id="element-1757" />
        <Consultation data-id="element-1758" />
      </main>
      <Footer data-id="element-1759" />
      <CookieBanner data-id="element-1760" />
      <FloatingContact data-id="element-1761" />
    </div>;
}